import styled from 'styled-components';
import { colors } from '../../css';

export const VisibleIcon = styled.div`
  width: 30px;
  height: 30px;
  display: inline-block;
  position: relative;
  transform: rotate(45deg);
  border: solid 2px ${colors.colorGrey04};
  border-top-left-radius: 80%;
  border-bottom-right-radius: 80%;

  &:before {
    content: '';
    width: 50%;
    height: 50%;
    display: block;
    position: absolute;
    bottom: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
    border: solid 2px ${colors.colorGrey04};
    border-radius: 50%;
  }

  &:after {
    content: '';
    width: 120%;
    height: 2px;
    display: none;
    position: absolute;
    bottom: 50%;
    left: 50%;
    transform: translate(-50%, 50%) rotate(90deg);
    background: ${colors.colorGrey04};
  }

  &.show-true:after {
    display: block;
  }
`;
